/**
 * created by xcc
 * 融媒用户管理页面
 */
import React, {Component} from 'react';
import {Table, Input, Button, Pagination, Select, Modal, Checkbox} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import AddUser from "./AddUser";
import $ from "jquery";
import {formatDate} from "../../../utils";
import BaseComponent from "../../../base/BaseComponent";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import {batchOperate_config} from "./batchOperation/batchOperate_config";

const {Search} = Input;
const {Option} = Select;

class UserList extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            offsite: 1,
            count: 10,
            total: 0,
            listData: [],  //列表数据
            hideOnSinglePage: true,
            screenObj: {},
            tsUserList: [],  //选中暂存的数据
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getListData();
    }

    getListData() {
        let params = {
            ...this.state.screenObj
        }
        this.request({
            url: "/cm-sites-mmp/rmUser/findUserList?offsite=" + this.state.offsite + "&count=" + this.state.count,
            method: "post",
            contentType: 'json',
            body: params,
            callBack: (res) => {
                let listData = [];
                let hideOnSinglePage = true;
                let total = 0;
                if (res && res.data && res.data.length) {
                    listData = res.data;
                    listData.forEach(item => {
                        item.checked = false;
                        this.state.tsUserList.forEach((i, index) => {
                            if (item.id === i.id) {
                                item.checked = true;
                            }
                        })
                    })
                    total = res.count;
                    hideOnSinglePage = false;
                }
                this.setState({
                    listData,
                    total,
                    hideOnSinglePage
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find("input").val("");
                })
            }
        });
    }

    renderAddModal() {
        return(
            <AddUser ref={(addUser) => this.addUser = addUser} showAllDept={true} refreshList={() => {
                this.getListData()
            }}/>
        )
    }

    getScreenList() {
        return (
            [
                {
                    key: "nickName",
                    field: "nickName",
                    placeholder: "请输入用户昵称",
                    type: "1",
                },
                {
                    key: "account",
                    field: "account",
                    placeholder: "请输入手机号",
                    type: "1",
                },
                {
                    key: "type",
                    field: "type",
                    placeholder: "请选择用户类型",
                    type: "2",
                    options: [
                        {
                            key: "1",
                            value: "1",
                            title: "外部人员"
                        },
                        {
                            key: "2",
                            value: "2",
                            title: "内部人员"
                        },
                        {
                            key: "3",
                            value: "3",
                            title: "内部管理"
                        },
                    ]
                },
                {
                    key: "status",
                    field: "status",
                    placeholder: "请选择用户状态",
                    type: "2",
                    options: [
                        {
                            key: "1",
                            value: "1",
                            title: "启用"
                        },
                        {
                            key: "2",
                            value: "2",
                            title: "禁用"
                        }
                    ]
                },
            ]
        )
    }

    renderHeader() {
        const screenList = this.getScreenList();
        return (
            <div style={{background: 'white', padding: "24px 15px", borderRadius: "5px 5px 0 0"}}>
                <div style={{display: "flex", alignItems: "center",}}>
                    {
                        screenList.length > 0 && screenList.map((item, index) => {
                            return (
                                (() => {
                                    switch (item.type) {
                                        case "1" :
                                            return <Search key={item.key} placeholder={item.placeholder}
                                                           style={{width: 250, marginRight: "20px"}}
                                                           value={this.state.screenObj[item.field]}
                                                           onChange={(e) => {
                                                               this.state.screenObj[item.field] = e.target.value;
                                                               this.setState({})
                                                           }}
                                                           onSearch={(searchValue) => {
                                                               this.screenChange(item.field, searchValue)
                                                           }}/>;
                                        case "2":
                                            return <Select key={item.key} placeholder={item.placeholder}
                                                           allowClear
                                                           value={this.state.screenObj[item.field]}
                                                           style={{width: 250, marginRight: "20px"}}
                                                           onChange={(value) => {
                                                               this.screenChange(item.field, value)
                                                           }}>
                                                {item.options.length > 0 && item.options.map(i => {
                                                    return <Option key={i.key} value={i.value}>{i.title}</Option>
                                                })}
                                            </Select>
                                        default:
                                            return null
                                    }
                                })()
                            )
                        })
                    }
                    <Button style={{marginRight: "20px"}} onClick={() => {
                        this.state.tsUserList = [];
                        this.state.count = 10;
                        this.screenChange();
                    }} type={"primary"}>
                        重置
                    </Button>
                </div>
                {this.renderBtn()}
            </div>
        )
    }

    renderBtn() {
        return(
            <div style={{display: "flex", alignItems: "center", marginTop: 20}}>
                <Button style={{marginRight: "20px"}} onClick={() => {
                    this.addUser.show()
                }} type={"primary"}>
                    新增用户
                </Button>
                {/*批量操作*/}
                {this.renderBatchOperate()}
            </div>
        )
    }

    renderBatchOperate() {
        let modules = batchOperate_config;
        return (
            <>
                {modules && modules.length ?
                    (
                        modules.map((module,i) => {
                            if (typeof module == "string") {
                                let batchModule = require(`./batchOperation/${module}`); // 引入
                                return (
                                    <div key={module}>
                                        <batchModule.default ref={(ref)=>{this[module]=ref}} tsUserList={this.state.tsUserList} refreshList={() => {this.refreshList()}}/>
                                    </div>
                                )
                            }else if(module.prototype instanceof Component){
                                let CustomModule = module;
                                return <CustomModule key={i} ref={(ref)=>{this[CustomModule.prototype.constructor.name]=ref}} tsUserList={this.state.tsUserList} refreshList={() => {this.refreshList()}}/>
                            }
                        })
                    )
                    : null}
            </>
        )
    }

    refreshList() {
        this.state.tsUserList = [];
        this.getListData();
    }

    screenChange(field, value) {
        if (value) {
            this.state.screenObj[field] = value
        } else {
            this.state.screenObj = Object.keys(this.state.screenObj).reduce((newData, key) => {
                if (field && ![field].includes(key)) {
                    newData[key] = this.state.screenObj[key];
                } else {
                    delete this.state.screenObj[key];
                    newData = this.state.screenObj;
                }
                return newData
            }, {})
        }
        this.state.offsite = 1;
        this.setState({}, () => {
            this.getListData()
        })
    }

    checkedAllChange(checked) {
        if (checked) {
            this.state.listData.forEach(item => {
                item.checked = checked;
                let num = 0;
                if (this.state.tsUserList.length > 0) {
                    this.state.tsUserList.forEach((Item) => {
                        if (item.id !== Item.id) {
                            num++
                        }
                    })
                    if (num === this.state.tsUserList.length) {
                        this.state.tsUserList.push(item)
                    }
                } else {
                    this.state.tsUserList.push(item)
                }
            });
        } else {
            this.state.listData.forEach(item => {
                item.checked = checked;
                this.state.tsUserList.forEach((Item, index) => {
                    if (item.id === Item.id) {
                        this.state.tsUserList.splice(index, 1)
                    }
                })
            })
        }
        this.setState({})
    }

    checkedSimpleChange(record) {
        if (!record.checked) {
            let aNum = 0;
            if (this.state.tsUserList.length > 0) {
                this.state.tsUserList.forEach((Item) => {
                    if (record.id !== Item.id) {
                        aNum++
                    }
                })
                if (aNum === this.state.tsUserList.length) {
                    this.state.tsUserList.push(record)
                }
            } else {
                this.state.tsUserList.push(record)
            }
        } else {
            this.state.tsUserList.forEach((item, index) => {
                if (item.id === record.id) {
                    this.state.tsUserList.splice(index, 1)
                }
            })
        }
        record.checked = !record.checked;
        this.setState({});
    }

    getColumns() {
        return (
            [
                {
                    title: (() => {
                        let checkedAll = this.state.listData.length ? this.state.listData.every(item => item.checked) : false;
                        let checkedLength = this.state.listData.length ? this.state.listData.filter(item => item.checked).length : 0
                        let indeterminate = this.state.listData.length && checkedLength > 0 && checkedLength < this.state.listData.length;
                        return (
                            <Checkbox checked={checkedAll} indeterminate={indeterminate} onChange={(e) => {
                                this.checkedAllChange(e.target.checked);
                            }}/>
                        )
                    })(),
                    key: 'select',
                    align: 'center',
                    width: 50,
                    render: (text, record) => {
                        return (
                            <div><Checkbox checked={record.checked} onChange={(e) => {
                                this.checkedSimpleChange(record);
                            }}/></div>
                        )
                    }
                },
                {
                    title: "头像",
                    key: 'photoUrl',
                    dataIndex: 'photoUrl',
                    ellipsis: true,
                    render: (text, record) => {
                        let photoUrl = text;
                        if (!text) {
                            photoUrl = 'images/header_boys.png';
                        }
                        return (
                            <div><img style={{width: "30px", height: "30px", objectFit: "cover", borderRadius: "50%"}}
                                      src={photoUrl} alt={""}/></div>
                        )
                    }
                },
                {
                    title: "昵称",
                    key: 'nickname',
                    dataIndex: 'nickName',
                    ellipsis: true,
                },
                {
                    title: "手机号",
                    key: 'account',
                    dataIndex: 'account',
                    ellipsis: true,
                },
                {
                    title: "用户类型",
                    key: 'type',
                    dataIndex: 'type',
                    ellipsis: true,
                    render: (text, record) => {
                        let userTypeName;
                        switch (text) {
                            case 1:
                                userTypeName = "外部人员";
                                break;
                            case 2:
                                userTypeName = "内部人员";
                                break;
                            case 3:
                                userTypeName = "内部管理";
                                break;
                            default:
                                userTypeName = "";
                        }
                        return (
                            <div>{userTypeName}</div>
                        )
                    }
                },
                {
                    title: "所属单位",
                    key: 'deptNames',
                    dataIndex: 'deptNames',
                    ellipsis: true,
                    width: 130,
                    render: (text, record) => {
                        return (
                            <div style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>{text && text.length && text.join("/")}</div>
                        )
                    }
                },
                // {
                //     title: "用户等级",
                //     key: 'grade',
                //     dataIndex: 'grade',
                //     ellipsis: true,
                //     render: (text, record) => {
                //         return (
                //             <div style={{
                //                 overflow: "hidden",
                //                 textOverflow: "ellipsis",
                //                 whiteSpace: "nowrap"
                //             }}>{text ? text : 0}</div>
                //         )
                //     }
                // },
                // {
                //     title: "历史积分",
                //     key: 'historyIntegral',
                //     dataIndex: 'historyIntegral',
                //     ellipsis: true,
                //     render: (text, record) => {
                //         return (
                //             <div style={{
                //                 overflow: "hidden",
                //                 textOverflow: "ellipsis",
                //                 whiteSpace: "nowrap"
                //             }}>{text ? text : 0}</div>
                //         )
                //     }
                // },
                // {
                //     title: "现有积分",
                //     key: 'nowIntegral',
                //     dataIndex: 'nowIntegral',
                //     ellipsis: true,
                //     render: (text, record) => {
                //         return (
                //             <div style={{
                //                 overflow: "hidden",
                //                 textOverflow: "ellipsis",
                //                 whiteSpace: "nowrap"
                //             }}>{text ? text : 0}</div>
                //         )
                //     }
                // },
                {
                    title: "状态",
                    key: 'status',
                    dataIndex: 'status',
                    ellipsis: true,
                    render: (text, record) => {
                        let status;
                        switch (text) {
                            case 1:
                                status = "启用";
                                break;
                            case 2:
                                status = "禁用";
                                break;
                            default:
                                status = "";
                        }
                        return (
                            <div>{status}</div>
                        )
                    }
                },
                {
                    title: "加入时间",
                    key: 'createTime',
                    dataIndex: 'createTime',
                    ellipsis: true,
                    width: 180,
                    render: (text, record) => {
                        return (
                            <div style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>{text ? formatDate(text) : ""}</div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 100,
                    render: (text, record) => {
                        return (
                            <div>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.addUser.show(record)}>编辑</span>
                                <span style={{color: "#0050B3", cursor: "pointer"}}
                                      onClick={() => this.delete(record)}>删除</span>
                            </div>
                        )
                    }
                }
            ]
        )
    }

    delete(record) {
        Modal.confirm({
            title: "确认删除该用户？",
            onOk: () => {
                this.request({
                    url: "/cm-sites-mmp/rmUser/remove",
                    body: {id: record.id},
                    method: "post",
                    callBack: (res) => {
                        if (res) {
                            message.success("删除成功");
                            if (this.state.listData.length === 1 && this.state.offsite > 1) {
                                this.paginationOnChange(this.state.offsite - 1, this.state.count)
                            } else {
                                this.paginationOnChange(this.state.offsite, this.state.count)
                            }
                        }
                    }
                });
            }
        })
    }

    renderTable() {
        let columns = this.getColumns();
        return (
            <div id="table" style={{background: 'white', borderRadius: " 0 0 5px 5px"}}>
                <div style={{boxSizing: "border-box", padding: "0 15px 10px 15px"}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={"calc(100vh - 296px)"}>
                        <Table rowKey={"id"} columns={columns} dataSource={this.state.listData} pagination={false}/>
                    </Scrollbars>
                </div>
                {this.state.listData && this.state.listData.length > 0 ? <div style={{
                    padding: "10px",
                    display: "flex",
                    justifyContent: "flex-end",
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #e6e6e6",
                    borderRadius: "0 0 5px 5px",
                }}>
                    <Pagination
                        onChange={(page, pageSize) => {
                            this.paginationOnChange(page, pageSize)
                        }}//页码改变回调
                        onShowSizeChange={(page, pageSize) => {
                            this.state.hideOnSinglePage = false;
                            this.paginationOnChange(page, pageSize)
                        }}//每页条数改变回调
                        defaultCurrent={1}
                        defaultPageSize={10}
                        total={this.state.total}
                        showTotal={total => `共${total}条`}
                        current={this.state.offsite}
                        pageSize={this.state.count}
                        showSizeChanger
                        showQuickJumper
                        hideOnSinglePage={this.state.hideOnSinglePage}
                    />
                </div> : ""}
                <style>{`
                    #table .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #table .ant-table-placeholder{border-bottom: 0;}
                `}</style>
            </div>
        )
    }

    paginationOnChange(page, pageSize) {
        this.state.offsite = page;
        this.state.count = pageSize;
        this.state.tsUserList = [];  //翻页时清空选中
        this.getListData();
    }

    /**
     * 渲染
     */
    render() {
        return (
            <div style={{margin: 15, height: "calc(100vh - 100px)"}}>
                {/*渲染头部*/}
                {this.renderHeader()}
                {/*渲染内容*/}
                {this.renderTable()}
                {/*渲染新增页面*/}
                {this.renderAddModal()}
            </div>
        )
    }
}

export default UserList;